import React from "react";
import "./ErrorContainer.css";
import errorIcon from "../../assets/error.png";

const ErrorContainer = ({
  message = "Oops! Something went wrong! Retry?",
  onReload = () => {},
}) => {
  return (
    <div className="error-container">
      <img src={errorIcon} alt="Error" />
      <div className="message">{message}</div>
      <div className="button" onClick={onReload}>
        Reload
      </div>
    </div>
  );
};

export default ErrorContainer;
